<template>
	<!-- Single upcoming match card -->
  <div class="a-vs-c-body">
      <!-- Betting history body -->
    <div class="left-tickets">
        <active-ticket
          v-for="(ticket, index) in tickets"
          :key="index"
          :ticket="ticket"
          :isHistory="true"
          :class="inputClass(selected, ticket.Status)"
          @onSelectItem="openTicket(ticket)" />
    </div>

    <div class="right-tickets expanded" v-if="currentTicket != null">
        <active-ticket
            :ticket="currentTicket"
            :isHistory="true"
            :hideWinning="true"
            :class="inputClass(selected, currentTicket.Status)"
            @onSelectItem="openTicket(currentTicket)" />
    </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import TimeFormatter from '@/mixins/TimeFormatter'
import VSoccerHelper from '@/mixins/VSoccerHelper'
import ActiveTicket from '@/components/soccer/ticket/ActiveTicket.vue'
import LanguageHelper from '@/mixins/LanguageHelper'

import vuexStore from '../../../store/vuexStore'

import activeBet from '../../../assets/audio/vSoccer/active_bet.mp3'

export default {
  components: {
    'active-ticket': ActiveTicket
  },
  mixins: [NumberFormat, TimeFormatter, VSoccerHelper, LanguageHelper],
  data () {
    return {
      currentTicket: null,
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  watch: {
    tickets: function (val, old) {
      this.currentTicket = null
    },
    mounted: function () {
      this.$watch(
        () => vuexStore.state.hasAudioEnabled,
        () => {
          this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
        }
      )
    }
  },
  props: {
    selected: String,
    tickets: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    getPossibleWinValue (ticket, isPossibleAT = true) {
      if (ticket.Status === 1) {
        if (isPossibleAT) {
          return this.format(ticket.PossibleWinAT)
        } else {
          return this.format(ticket.PossibleWinBT)
        }
      }
      return this.format(0.00)
    },
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers(), 2)
    },
    toggleTicketView (ticket) {
      ticket.isOpen = !ticket.isOpen
    },
    openTicket (ticket) {
      if (this.hasAudioEnabled) {
        var audio = new Audio(activeBet)
        audio.play()
      }
      this.currentTicket = ticket
    },
    getStatus: function (ticket) {
      let status = 'active'
      if (ticket.Status === 1) {
        status = 'winning'
      } else if (ticket.Status === 0) {
        status = 'losing'
      }
      return status
    },
    isActiveTicket: function (ticket) {
      return ticket.Status === 2
    },
    isLostTicket: function (ticket) {
      return ticket.Status === 0
    }
  }
}
</script>
